import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import { Translation } from 'react-i18next'
import { MAX_LOGO_HEIGHT, MAX_LOGO_WIDTH } from '../../constants/index'

const styles = (theme) => ({
  inputContainer: {
    display: 'none'
  },
  buttonContainer: {
    paddingTop: theme.spacing(2),
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-evenly'
  },
  button: {
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
    float: 'right',
    marginBottom: '20px'
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    maxWidth: MAX_LOGO_WIDTH + 'px',
    maxHeight: MAX_LOGO_HEIGHT + 'px',
    margin: '25px',
    border: '1px dashed gray',
    padding: '2rem 0',
    borderRadius: 15
  },
  image: {
    maxWidth: '100%',
    maxHeight: MAX_LOGO_HEIGHT + 'px'
  },
  logoHintText: {
    WebkitUserSelect: 'none',
    userSelect: 'none',
    fontSize: '14px',
    color: '#ABABAB',
    padding: '3rem 0'
  }
})

const Logo = ({
  logo,
  setAddingLogo,
  addingLogo,
  saveLogo,
  deleteLogo,  
  invalidLogo,
  classes,
  userType  
}) => {
  const [dataUrl, setDataUrl] = useState(null)
  const [file, setFile] = useState(null)
  const [isValid, setIsValid] = useState(false)
  const fileHandler = (event) => {
    if (event.target.files[0]) {
      var type = event.target.files[0].type
      if (type === 'image/png' || type === 'image/jpeg') {
        setFile(event.target.files[0])
        let reader = new FileReader()
        reader.onload = (e) => {
          setDataUrl(e.target.result)
          setAddingLogo(true)
        }
        reader.readAsDataURL(event.target.files[0])
      } else {
        handleInvalidLogoFormat()
      }
    }
  }

  const handleInvalidLogoFormat = () => {
    clearFileInput()
    invalidLogo('format')
  }

  const handleCorruptFile = () => {
    clearFileInput()
    if (!logo) invalidLogo('corrupt')
  }

  const handleValidFile = () => {
    setIsValid(true)
  }

  const handleSave = () => {
    saveLogo(file)
  }

  const handleCancel = () => {
    clearFileInput()
    setAddingLogo(false)
  }

  const handleDelete = () => {
    clearFileInput()
    deleteLogo()
  }

  const clearFileInput = () => {
    setIsValid(false)
    setFile(null)
    setDataUrl(null)
    const input = document.getElementById('input-logo')
    if (input && input.value) input.value = null
  }

  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <div className="col-xs-12 col-sm-12 col-lg-12" style={{padding: 0, maxHeight: '360px'}}>
              <div className="panel panel-default" style={{padding: 0, margin: 0}}>
                <div className="dashboard-content-header">
                    <h1>{t('profile.logo')}</h1>
                </div>
                <div className={classes.imageContainer}>
                  {logo || dataUrl ? (
                    <img
                      src={logo ? logo.path : dataUrl}
                      alt=""
                      className={classes.image}
                      onError={handleCorruptFile}
                      onLoad={handleValidFile}
                    />
                  ) : (
                    <p className={classes.logoHintText} disabled={true}>
                      {t('profile.logoFormat')}
                    </p>
                  )}
                </div>
                <div className={classes.buttonContainer}>
                  {file && addingLogo && isValid ? (
                    <React.Fragment>
                      <Button
                        id="cancelLogoBtn"
                        variant="contained"
                        className={classes.button}
                        onClick={handleCancel}
                      >
                        {t('invoice.dialogCancel')}
                      </Button>
                      <Button
                        id="uploadLogoBtn"
                        variant="contained"
                        className={classes.button}
                        onClick={handleSave}
                      >
                        {t('profile.save')}
                      </Button>
                    </React.Fragment>
                  ) : file || logo ? (
                    <Button
                      id="deleteLogoBtn"
                      variant="contained"
                      className={classes.button}
                      onClick={handleDelete}
                      disabled={userType == 2 ? true : false}
                    >
                      {t('profile.deleteLogo')}
                    </Button>
                  ) : (
                    <Button
                      id="addLogoBtn"
                      variant="contained"
                      component="label"
                      htmlFor="input-logo"
                      className={classes.button}
                      disabled={userType == 2 ? true : false}
                    >
                      {t('profile.addLogo')}
                    </Button>
                  )}
                </div>
                <div className={classes.inputContainer}>
                  <input
                    type="file"
                    name="inputFile"
                    id={'input-logo'}
                    onChange={fileHandler}
                    accept="image/png,.jpg,.jpeg"
                  />
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

Logo.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Logo)